
const UrlSegment = {
  url: 'Enrollment'
};


export const actionsPack = {

  Rechazar: {
    verb: 'rechazar la suscripción',
    icon: 'cancel',
    title: 'Rechazo de usuario',
    btnTitle: 'Rechazar',
    apiAction: {
      param: 'Reject',
      //? se establece como opcion si debe enviar o no el memberId en la peticion
      isMemberIdRequired: true
    },
    body: {
      enrollmentId: null,
      email: null
    },

    urlTarget: {
      type: 'param',
     

      getInit: function () {
        return `${UrlSegment.url}/Reject`
      }
    },
    key: 1
  },

  Reenviar: {
    verb: 'reenviar el email de inscripción',
    icon: 'forward_to_inbox',
    title: 'Reenvío de usuario',
    btnTitle: 'Reenviar',
    apiAction: {
      param: 'ResendInscriptionMail',
      isMemberIdRequired: true
    },
    body: {
      enrollmentId: null,
      email: null
    },

    urlTarget: {
      type: 'param',
    

      getInit: function () {
        return `${UrlSegment.url}/ResendInscriptionMail`
      }
    },
    key: 2
  },

  Inhabilitar: {
    verb: 'Bloquear',
    icon: 'lock',
    title: 'Bloqueo de usuario',
    btnTitle: 'Inhabilitar',
    apiAction: {
      param: 'BlockMember',
      isMemberIdRequired: false
    },
    body: {
      email: null
    },

    urlTarget: {
      type: 'query',
    

      getInit: function (body) {
        return `${UrlSegment.url}/BlockMember?email=${body?.email}`;
      }
    },
    key: 3
  },
  // Esto deberia ser aprobar 
  Aprobar: {
    verb: 'habilitar',
    icon: 'how_to_reg',
    title: 'Habilitación de usuario',
    btnTitle: 'Habilitar',
    apiAction: {
      param: 'Approve',
      isMemberIdRequired: true
    },
    body: {
      enrollmentId: null,
      email: null
    },

    urlTarget: {
      type: 'param',
    
      getInit: function () {
        return `${UrlSegment.url}/Approve`
      }
    },

    key: 4
  },
  //aca falta unblockMember
  Habilitar: {
    verb: 'Desbloquear',
    icon: 'lock_open',
    title: 'Habilitación de usuario',
    btnTitle: 'Desbloquear',
    apiAction: {
      param: 'UnblockMember',
      isMemberIdRequired: false
    },
    body: {
      email: null
    },

    urlTarget: {
      type: 'query',
    
      getInit: function (body) {
        return `${UrlSegment.url}/UnblockMember?email=${body?.email}`;
      },
    },

    key: 6
  },

  Ver: {
    verb: 'Ver Usuario',
    icon: 'visibility',
    title: 'Ver usuario',
    key: 5
  },

  Renovar: {
    verb: 'Renovar',
    icon: 'refresh',
    title: 'Renovar membresía',
    btnTitle: 'Renovar',
    apiAction: {
      param: 'Renew',
      isMemberIdRequired: true
    },
    body: {
      enrollmentId: null,
      memberId: null
    },
    urlTarget: {
      type: 'query',

      getInit: function (body) {
        return `${UrlSegment.url}/Renew?enrollmentId=${body?.enrollmentId}&memberId=${body?.memberId}`;
      },

    },

    key: 7
  }


};